import { forwardRef, HTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

interface IFormInputWrapperProps extends HTMLAttributes<HTMLLabelElement> {
  invalid: boolean;
  disabled?: boolean;
}

/** Core input have no styles so this wrapper adds border and outline and other things to it. */
export const FormInputWrapper = forwardRef<
  HTMLLabelElement,
  IFormInputWrapperProps
>(({ invalid, disabled, ...props }, ref) => {
  return (
    <label
      ref={ref}
      {...props}
      className={twMerge(
        "rounded-lg shadow-xs transition-all border outline outline-1 outline-transparent flex items-center",
        disabled ? "cursor-auto" : "cursor-text",
        disabled
          ? "border-gray-v2-300 bg-gray-v2-50"
          : invalid
            ? "border-error-v2-300 focus-within:border-error-v2 focus-within:outline-error-v2"
            : "border-gray-v2-300 focus-within:border-brand-v2 focus-within:outline-brand-v2",
        props.className
      )}
    >
      {props.children}
    </label>
  );
});

FormInputWrapper.displayName = "FormInputWrapper";
